// Dots and Boxes page entry.
import { DotsGame } from "../board/dots-ui"

const root = document.getElementById("board")
if (root) (window as unknown as { dtGame?: DotsGame }).dtGame = new DotsGame(root)
